import React, { useEffect } from 'react';

import './snackbar.scss';

import { connect } from 'react-redux';

import { hideAppNotification } from 'hb-redux-store/initial.action';

import Icon from '../../mweb/Icon/Icon';

// CONSTANTS
const SNACKBAR_DEFAULT_TIMEOUT = 3000;

let snackbarTimeout;

const Snackbar = props => {
  const { hideAppNotification } = props;
  const { show, message, timeout, cancellable } = props.notification;
  useEffect(() => {
    if (show) {
      if (snackbarTimeout) {
        clearTimeout(snackbarTimeout);
      }
      snackbarTimeout = setTimeout(() => {
        hideAppNotification();
      }, timeout);
      return () => {
        clearTimeout(snackbarTimeout);
      };
    }
  }, [show, message]);
  if (!show) return null;
  return (
    <div className="container">
      <div className="content">
        {message}
        {cancellable && (
          <div onClick={() => hideAppNotification()}>
            <Icon size={20} class={'icon-common-close-white'} />
          </div>
        )}
      </div>
    </div>
  );
};

Snackbar.defaultProps = {
  notification: {
    show: false,
    message: '',
    timeout: SNACKBAR_DEFAULT_TIMEOUT,
    cancellable: true,
  },
};

const mapStateToProps = state => ({
  notification: state.initialReducer.notification,
});

const mapDispatchToProps = { hideAppNotification };

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);
